package tta.destinigo.talktoastro.feature_call_consultation.domain.model

import tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_status_bottomsheet.QueueUser

data class QueueStatusUiData(
    val channelName:String?,
    val eventKey:String?,
    val inactiveUserText:String,
    val user: List<QueueUser>
)